<div class="container-lg container-reservation">
    <h1>Prenez rendez-vous avec un membre de l'équipe</h1>
    
    <h2 class="h2">Vous pourrez bientôt reserver vos séances ici</h2>
    
    <p class="waiting">En attendant n'hésitez pas à nous appeler ou nous envoyer un mail.</p>

    <h3 class="h3">Pour contacter Jordan le coach</h3>
    <p class="by-phone">par téléphone: <span class="num-tel">0616346696</span></p>
    <p class="by-mail">ou par mail: <a class="btn btn-sm" role="button" href="mailto:heat.training13@gmail.com">heat.training13@gmail.com</a></p>
    
    <h3 class="h3">Pour contacter Manon la diététicienne</h3>
    <p class="by-phone">par téléphone: <span class="num-tel">0615035428</span></p>
    <p class="by-mail">ou par mail: <a class="btn btn-sm" role="button" href="mailto:manon.geynet@outlook.fr">manon.geynet@outlook.fr</a></p>
</div>
